import axiosInstance from "./axiosInstance";

const CHECKIN_API_URL = process.env.REACT_APP_CHECKIN_API_URL ?? "https://dev-api.checkin.degencoinflip.com/v1"; // Replace with your actual API base URL

export interface CheckInResponse {
  message: string;
  payload: {
    token: string;
    externalId: string;
    responseCode: number;
  };
}

export const getCheckInToken = async (): Promise<{ token: string; externalId: string }> => {
  try {
    const response = await axiosInstance.get<CheckInResponse>(
      `${CHECKIN_API_URL}/checkin/key`
    );
    return response.data.payload;
  } catch (error) {
    console.error("Error fetching CheckIn token:", error);
    throw new Error("Failed to fetch verification token");
  }
};
